import { Icon } from '@chakra-ui/react';

export const CheckIcon = (props: any) => (
  <Icon aria-label="check icon" viewBox="4 4 16 16" {...props}>
    <path
      d="m11.4520971 12.6236699 2.7590485-5.51809709c.4939785-.987957 1.6953246-1.38840569 2.6832816-.89442719s1.3884057 1.69532458.8944272 2.68328157l-4 8.00000001c-.6104982 1.2209964-2.2377856 1.4850688-3.203068.5197864l-3.99999996-4c-.78104859-.7810486-.78104859-2.0473786 0-2.8284272.78104858-.78104855 2.04737854-.78104855 2.82842712 0z"
      fill="currentColor"
    />
  </Icon>
);
